import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"560px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "sb-modal-title" }
const _hoisted_5 = { class: "sb-intro" }
const _hoisted_6 = {
  key: 0,
  class: "sb-seg"
}
const _hoisted_7 = { class: "sb-entry" }
const _hoisted_8 = { class: "sb-e-l" }
const _hoisted_9 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "sb-intro"
}
const _hoisted_12 = { class: "sb-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.metric ? _ctx.metric.Name : 'Numbers for ' + _ctx.weekRangeNumbered(_ctx.week)), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.metric ? _ctx.ownerName(_ctx.metric) + ' · goal ' + _ctx.goalText(_ctx.metric, _ctx.week) + '. Fix a past week here if a number was wrong.' : 'Green means on goal.'), 1),
      (!_ctx.metric && _ctx.myMetrics.length && _ctx.myMetrics.length < _ctx.metrics.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(_ctx.onlyMine ? 'on' : ''),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onlyMine = true))
            }, "Mine (" + _toDisplayString(_ctx.myMetrics.length) + ")", 3),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(!_ctx.onlyMine ? 'on' : ''),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onlyMine = false))
            }, _toDisplayString(_ctx.team ? 'Whole ' + _ctx.teamLabel(_ctx.team) + ' Scoreboard' : 'All Found'), 3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.key,
            class: "sb-erow"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("b", null, _toDisplayString(row.title), 1),
              _createElementVNode("span", null, _toDisplayString(row.sub), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["sb-e-in", _ctx.stateClass(row)])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "any",
                "onUpdate:modelValue": ($event: any) => ((_ctx.values[row.key]) = $event),
                placeholder: "—",
                "aria-label": row.title
              }, null, 8, _hoisted_9), [
                [_vModelText, _ctx.values[row.key]]
              ]),
              (row.metric.Unit)
                ? (_openBlock(), _createElementBlock("em", _hoisted_10, _toDisplayString(row.metric.Unit), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 128)),
        (!_ctx.rows.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "No metrics here yet."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        _createElementVNode("div", {
          class: "btn-light",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, "Cancel"),
        _createElementVNode("div", {
          class: _normalizeClass(["btn", _ctx.saving ? 'disable-button' : '']),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save()))
        }, "Save Numbers", 2)
      ])
    ])
  ]))
}